import { render, staticRenderFns } from "./CRMOld.vue?vue&type=template&id=6b85a7f4&scoped=true"
import script from "./CRMOld.vue?vue&type=script&lang=js"
export * from "./CRMOld.vue?vue&type=script&lang=js"
import style0 from "./CRMOld.vue?vue&type=style&index=0&id=6b85a7f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b85a7f4",
  null
  
)

export default component.exports